// extracted by mini-css-extract-plugin
export var hideEditor = "_m4-2";
export var infoIcon = "_m4-3";
export var label = "_m4-1";
export var labelContainer = "_m4-0";
export var readonlyText = "_m4-4";